<template>
  <v-footer :fixed="false" absolute class="px-0 mt-10" color="transparent">
    <v-row no-gutters>
      <div>
        <v-btn
          v-for="link in links"
          :key="link.link"
          color="primary"
          text
          :href="link.link"
          :target="link.target"
          class="text-capitalize ml-1 font-weight-regular"
        >
          {{ link.text }}
        </v-btn>
      </div>
    </v-row>
    <cookie-law theme="base" buttonText="Agree">
      <div slot="message">
        เว็บไซต์นี้ใช้คุกกี้ เพื่อเพิ่มประสิทธิภาพการใช้งานให้กับผู้ใช้
        ท่านตกลงใช้คุกกี้เพื่อใช้งานเว็บไซต์นี้ต่อไป
      </div>
    </cookie-law>
  </v-footer>
</template>

<script>
import config from "../../config";
import CookieLaw from "vue-cookie-law";
export default {
  name: "Footer",
  components: { CookieLaw },
  data: () => ({
    config,

    links: [
      { text: "IADTH", link: "http://www.iadth.com" },
      {
        text: "คู่มือการใช้งาน",
        link: "/Manual/Manual",
      },
      /*{
        text: "ไฟล์ Template",
        link: "https://iadth-my.sharepoint.com/:f:/p/it01/EpZMtFAy4yhMonb5cMBRfAQBQ5YYPtXmFo8HMoNzZ21s1A?e=XeQFUO",
        "download": true
      },*/
    ],
  }),
};
</script>

<style src="./Footer.scss" lang="scss" />
